<!-- <div class="notification-wrapper {{notificationService.bgType}}"
[ngClass]="{'pushdown': notificationService.isNotificationHidden}" >
<i class="fa fa-times" 
    style="position:absolute;top:0;right:3px;font-size:0.9em;cursor:pointer;" 
    [hidden]=!notificationService.manualDismiss (click)="closeNotice()">
</i>
<div >{{notificationService.message}}</div>
<i style="margin: 0 4px 0 4px;" class="notification-icon fa {{notificationService.iconType}}"></i>
</div> -->

<div class="notification-wrapper {{notificationService.bgType}}"
[ngClass]="{'pushdown': notificationService.isNotificationHidden}" >
<i class="fa fa-times" 
    style="position:absolute;top:0;right:3px;font-size:0.9em;cursor:pointer;" 
    [hidden]=!notificationService.manualDismiss (click)="closeNotice()">
</i>
<div >{{notificationService.message}}</div>
<i style="margin: 0 4px 0 4px;" class="notification-icon fa {{notificationService.iconType}}"></i>
</div>